import ReactDOM from 'react-dom';

export const loadReact = (element, Component) => {
    const callback = () => {
        ReactDOM.render(Component, element);
    };
    Promise.resolve().then(callback);
};


export const loadNative = (callback) => {
    // works async-ly and is cleaner than setTimeout
    Promise.resolve().then(callback);
};



// WEBPACK FOOTER //
// ./src/utils/dynamicLoader.js